import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

/** Keeps the selected agent in the URL so a drill-down stays shareable. */
const useAssessmentCompletionFilters = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const agentId = useMemo(() => {
        const parsed = Number(searchParams.get('agentId'));
        return Number.isInteger(parsed) && parsed > 0 ? parsed : undefined;
    }, [searchParams]);

    const setAgentId = useCallback(
        (value?: number) => {
            setSearchParams(
                (current) => {
                    const next = new URLSearchParams(current);
                    if (value == null) next.delete('agentId');
                    else next.set('agentId', String(value));
                    return next;
                },
                { replace: true }
            );
        },
        [setSearchParams]
    );

    return { agentId, setAgentId };
};

export default useAssessmentCompletionFilters;
